<!--Componente que contiene los afiliados, afiliados del mes, Afiliaciones atrasadas se muestra 
  en la parte superior del dashboard de organización (Se usa en la vista src/views/admin/Home.vue)-->
<template>
  <v-row justify="space-around">
    <!-- SKELETON LOADER -->
    <v-col cols="10" v-if="loading">
      <v-row justify="space-between">
        <v-col cols="12" sm="4" xl="3" v-for="n in 3" :key="n">
          <v-sheet :color="`grey lighten-4`">
            <v-skeleton-loader
              class="pa-2 skeleton-card"
              type="list-item-avatar-two-line"
              :loading="loading"
              transition="scale-transition"
            ></v-skeleton-loader>
          </v-sheet>
        </v-col>
      </v-row>
    </v-col>

    <!-- LISTA DE TARJETAS -->
    <v-col v-else cols="12" sm="4" xl="3" v-for="(item, index) in analytics" :key="index">
      <analytic-card
        :title="item.title"
        :description="item.description"
        :icon="item.icon"
        :currency="item.currency"
      ></analytic-card>
    </v-col>
  </v-row>
</template>
<script>
import AnalyticCard from "./analytic-card";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  data() {
    return {
      analytics: [],
      loading: true,
    };
  },
  components: {
    AnalyticCard
  },
  methods: {
    ...mapActions("plan", ["fetchUserPlans"]),
    ...mapMutations("user", ["logout"]),
    /**
     * Función para obtener los datos de las tarjetas iniciales en el panel del administrador.
     */
    async getAnalytics() {
      let affiliates = 0;
      let newAffilliates = 0;
      let latePayments = 0;

      let year, month, day;
      let interval = 0;
      const currentDate = new Date();

      let lastMonthAffiliates = currentDate;
      lastMonthAffiliates.setMonth(lastMonthAffiliates.getMonth()-1);

      for (let plan of this.plans) {
        if (plan.affiliations.length > 0) {
          for (let affiliate of plan.affiliations) {
            if (affiliate.estatus === "ACTIVE") {
              // SI EL AFILIADO ESTÁ ACTIVO
              affiliates += 1;

              // OBTENEMOS LA FECHA DE PAGO A PARTIR DE LA FECHA DE EXPIRACIÓN - EL INTERVALO
              if (affiliate.expirationDate!=null){
                let expirationDate = affiliate.expirationDate
                  .substring(0, 10)
                  .split("-");
                year = Number(expirationDate[0]);
                month = Number(expirationDate[1]) - 1;
                day = Number(expirationDate[2]);
                interval = affiliate.tier.interval === "month" ? 1 : 12;
                let paymentDate = new Date(year, month, day);
                paymentDate.setMonth(month - interval);
                // SI EL PAGO FUE EN EL MES ACTUAL
                if (
                  paymentDate >= lastMonthAffiliates
                )
                  newAffilliates += 1;

                // SI LA FECHA DE EXPIRACIÓN ES MENOR A LA FECHA ACTUAL
                if (
                  currentDate.getMonth() > month - 1 &&
                  currentDate.getFullYear() === year
                )
                  latePayments += 1;
              }
            }
          }
        }
      }

      this.analytics = [
        {
          title: "Afiliados",
          description: affiliates,
          icon: "fas fa-medal",
          currency: false
        },
        {
          title: "Afiliaciones del mes",
          description: newAffilliates,
          icon: "fas fa-calendar-plus",
          currency: false
        },
        {
          title: "Afiliaciones atrasadas",
          description: latePayments,
          icon: "fas fa-user-clock",
          currency: false
        }
      ];
    }
  },
  computed: {
    ...mapState("plan", ["plans"])
  },
  async mounted() {
    try {
      await this.fetchUserPlans();
    } catch(e) {
      if (e.message == 'GraphQL error: Autenticacion requerida ') {
        this.logout();
        this.$router.push("/login");
      }
    }
    await this.getAnalytics();
    this.loading = false;
  }
};
</script>
<style scoped>
.v-skeleton-loader >>> .v-skeleton-loader__list-item-two-line,  .v-skeleton-loader >>> .v-skeleton-loader__list-item-avatar-two-line{
  min-height:100px;
}
</style>